import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/style/appDropdown.css';
import './assets/style/login.css';
import './assets/style/index.css';
import './assets/style/nav-bar.css';
import './assets/style/nav-bar-alt-1.css';
import './assets/style/work-info.css';
import './assets/style/wh.css';
import './assets/style/colors.css';
import './assets/style/font-family.css';
import './assets/style/font-size.css';
import './assets/style/dashboard.css';
import './assets/style/input.css';
import './assets/style/dropdown.css';
import './assets/style/print.css';
import './assets/style/pretty-json.css';
import './assets/style/table-classic.css';
import './assets/style/tree.css';
import './assets/style/gantt.css';
import './assets/style/tiptap.css';
import './assets/style/task-mng.css';
import './assets/style/masonry.css';
import './assets/style/module-hub.css';
import './assets/style/birthday.css';
import './assets/style/chat.css';
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import './i18n';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { AuthProvider } from './context/AuthProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </AuthProvider>
  </React.StrictMode>
);